import {ReactComponent as SearchIcon} from "../../../../images/viewChart.svg";
import {LinkButton} from "../../../common/link-button/LinkButton";
import {DateDisplay} from "../../../common/date-display/DateDisplay";
import {PatientSearchResult} from "../../../../services/medicationmanagement/patientApi/models/PatientSearchResult";
import {ResidentImage} from "../../../common/resident-image/ResidentImage";
import {UserType} from "../../../../services/medicationmanagement/medsUser/MedsUserApi";
import {DateFormats} from "../../../common/enums/DateFormat";
import {StatusDisplay} from "../StatusDisplay";
import {ChartExpiryDisplay} from "../ChartExpiryDisplay";
import {FacilityDisplay} from "../FacilityDisplay";
import {RenderIf} from "../../../common/render-if/RenderIf";
import { AllergyStatusDisplay } from "../AllergyStatusDisplay";
import { CourseStatusDisplay } from "../CourseStatusDisplay";
import {Grid, TableCell,  TableRow, Box as Mbox} from "@material-ui/core";
import classes from './../ResidentTable.module.scss';
import {ReactComponent as OnboardingIcon} from "../../../../images/viewChartOnboarding.svg";
import { PhoneOrderDisplay } from "../PhoneOrderDisplay";
import { PatientMedsSatusDetails } from "../../../../services/medicationmanagement/patientApi/models/PatientMedsExpireDetails";
import { useEffect, useReducer, useState } from "react";
import { getExpiringMedsSummary } from "../../../../services/medicationmanagement/medications/MedicationsApi";
import { ExpandRowLoader } from "./ExpandRowLoader";
import { ResidentMedsState, ResidentRowActions, RowActionTypes, getResidentName, residentMedicationDetailsReducer } from "./ResidentTableRowHelper";
import { CourseExpiryFilterSubType } from "../../../../services/medicationmanagement/patientApi/models/ExpiryFilterType";
import { MedicationExpiryDisplay } from "./MedicationExpiryDisplay";
import moment from 'moment';
 
export const ResidentTableRow = (props:{data:PatientSearchResult, userType:UserType}) => {
    var resident = props.data;
    var userType = props.userType;

    let [uiState, setUiState] = useState(ResidentRowActions.Collapse)
    
    let [retryCount, SetRetry] = useState(0)

    let [medsState,dispatch] = useReducer(residentMedicationDetailsReducer, {
        progress:RowActionTypes.InitialiseDetails
    } as ResidentMedsState);
    
    useEffect(() => {
        if(uiState ===  ResidentRowActions.Expand){
            dispatch([RowActionTypes.StartLoadingDetails, null]);
            let searchStorage = JSON.parse(localStorage.getItem('search')!);    
            let courseExpiryFilterSubType = searchStorage? searchStorage.courseExpiryFilterSubType : CourseExpiryFilterSubType.CourseExpiryInSevenDays;   
            getExpiringMedsSummary(resident.authoringSystem, resident.authoringSystemForeignKey, courseExpiryFilterSubType)
            .then((data :PatientMedsSatusDetails) => {
                dispatch([RowActionTypes.DetailsLoaded, {
                    residentId:data.patientId,
                    expiredMeds:data.expiredMeds,
                    expiringMeds:data.expiringMeds
                }]);
            }).catch(_=>{
                dispatch([RowActionTypes.DetailsLoadingFailed, null]);
            });
        }

    }, [uiState, resident.authoringSystem, resident.authoringSystemForeignKey, retryCount]);

    const onCollapsedRowClicked = () => {
        dispatch([RowActionTypes.ResetDetails, null]);
        setUiState(ResidentRowActions.Collapse);
    }

    const onStatusBadgeClicked = (uiState: any) => {
        let newState  =uiState === ResidentRowActions.Collapse ?  
        ResidentRowActions.Expand :  ResidentRowActions.Collapse
        setUiState(newState)
    }

    let dataLoading = medsState.progress===RowActionTypes.StartLoadingDetails;
    let dataLoadingError = medsState.progress===RowActionTypes.DetailsLoadingFailed
    let expiredMeds = medsState.data?.expiredMeds;
    let expiringMeds = medsState.data?.expiringMeds;

    return (
    <>
        <TableRow  className={classes.tableBody}>
            <TableCell className={uiState === ResidentRowActions.Expand ? classes.expandRow : ""}>
                <Grid container spacing={1} className={classes.resident}>
                    <Grid item>
                        <ResidentImage
                            authoringSystem={resident.authoringSystem}
                            authoringSystemForeignKey={resident.authoringSystemForeignKey}
                            imageWidth={50}
                            imageHeight={50}
                        />
                    </Grid>
                    <Grid item>
                        <Mbox>
                            {getResidentName(
                                resident.givenName,
                                resident.familyName,
                                resident.middleNames,
                                resident.preferredName
                            )}
                            <Mbox className={classes.residentDetails}>
                                <Mbox className={classes.muted}>
                                    <DateDisplay
                                        date={resident.dateOfBirth}
                                        format={DateFormats.DDMMMYYYY}
                                        isTextBold={false}
                                    />{" "}
                                    |&nbsp; {resident.age} years old |&nbsp;{" "}
                                    {resident.sex?.name}
                                </Mbox>
                                <RenderIf if={resident?.residentWithSimilarNamePresent}>
                                    <Mbox className={classes.critical}>
                                        There is a resident with a similar or same name
                                    </Mbox>    
                                </RenderIf>
                                
                            </Mbox>
                            
                        </Mbox>
                    </Grid>
                </Grid>
            </TableCell>
            <TableCell className={uiState=== ResidentRowActions.Expand ? classes.expandRow : ""}>
                <FacilityDisplay
                    facilityName={resident.facility?.name}
                    organisationName={resident.facility?.organisation?.name}
                    />
            </TableCell>
            <TableCell className={uiState === ResidentRowActions.Expand ? classes.expandRow : ""}>
                <DateDisplay
                    date={resident.chart?.updatedDate}
                    format={DateFormats.DDMMMYYYYHyphen}
                    isTextBold={false}
                />
                <RenderIf if={resident.chart?.updatedDate !== undefined}>
                <span className={classes.updatedTime}>{moment(resident.chart?.updatedDate).format('HH:mm')}</span>
                </RenderIf>
            </TableCell>
            <TableCell className={uiState === ResidentRowActions.Expand ? classes.expandRow : ""}>
                <DateDisplay
                    date={resident.chart?.expiryDate}
                    format={DateFormats.DDMMMYYYYHyphen}
                    isTextBold={false}
                    />
                    <RenderIf if={userType === UserType.Doctor 
                                || userType == UserType.Dentist 
                                || userType == UserType.GeneralStaffAdmin 
                                || userType == UserType.NursePractitioner 
                                || userType == UserType.Optometrist 
                                || userType == UserType.RegisteredNurse }>
                    
                    <ChartExpiryDisplay
                        isReviewSoonRequired={
                            resident.statuses?.isReviewSoonRequired
                        }
                        numberOfDaysToExpiry={
                            resident.chart?.numberOfDaysToExpiry
                        }
                        isReviewDue={resident.statuses?.isReviewDue}
                    />
                    </RenderIf>
            </TableCell>
            <TableCell className={uiState === ResidentRowActions.Expand ? classes.expandRow : ""}>
                <Mbox className={classes.badges}>
                    <StatusDisplay statuses={resident.statuses} userType={userType}
                        chartReviewConfiremd={true}
                    />
                    <CourseStatusDisplay isCourseExpiringSoon={resident.statuses.isCourseExpiringSoon} 
                                            isCourseExpired={resident.statuses.isCourseExpired}
                                            courseExpiredMedsCount = {resident.courseExpiredMedsCount}
                                            courseExpiringSoonMedsCount= {resident.courseExpiringSoonMedsCount}
                                            uiState = {uiState}
                                            onStatusBadgeClicked ={onStatusBadgeClicked}
                                            />
                    <AllergyStatusDisplay hasAllergyUpdated={resident.hasAllergyUpdated} userType={userType} />
                    <PhoneOrderDisplay hasOpenPhoneOrder={resident.statuses.hasOpenPhoneOrder}/>
                </Mbox>
            </TableCell>
            <TableCell className={uiState === ResidentRowActions.Expand ? classes.expandRow : ""}>
                
                <LinkButton
                    startIcon={
                        resident.isOnboarding ? <OnboardingIcon /> : <SearchIcon />                                          
                }
                    to={(location:any)=>{
                    let basePath = userType === UserType.Doctor 
                                    || userType === UserType.Dentist 
                                    || userType === UserType.GeneralStaffAdmin 
                                    || userType === UserType.NursePractitioner 
                                    || userType === UserType.Optometrist 
                                    || userType === UserType.RegisteredNurse 
                    ? `${location.pathname}/gp`
                    : `${location.pathname}/pharmacy`;
                    return `${basePath}/${resident.authoringSystem}/${resident.authoringSystemForeignKey}`
                    }
                }
                isOnboarding={resident.isOnboarding}
                >
                    View chart
                </LinkButton>
            </TableCell>
            
        </TableRow>
        
        { uiState === ResidentRowActions.Expand &&
        <TableRow>
            <TableCell colSpan={6}>
                <ExpandRowLoader inProgress={dataLoading} error={dataLoadingError} onRetryClicked = {() => SetRetry(retryCount + 1)}>
                    <MedicationExpiryDisplay expiredMeds = {expiredMeds} expiringMeds = {expiringMeds}  onClose = {onCollapsedRowClicked}></MedicationExpiryDisplay>
                </ExpandRowLoader>
            </TableCell>
        </TableRow>
        }
    </>
)}